import { FC, useMemo, memo } from 'react';

import { Avatar, LikeButton, RepostButton, Video } from 'react-activity-feed';

import { Activity as ActivityType } from '../../../types/feed';

import { getTimeFromNow } from '../../../utils/time';
import { getActorName } from '../../../utils/feeds';

import avatar from '../../../images/avatar.png';

import styles from './Activity.module.css';

export type Props = {
  repost: boolean;
  activity: ActivityType;
  noFooter: boolean;
};

export const ActivityComponent: FC<Props> = (activityProps: any) => {
  const { activity, noFooter } = activityProps;
  const activityTime = useMemo(() => {
    return getTimeFromNow(activity?.time);
  }, [activity.time]);
  const actorName = getActorName(activity.actor);
  return (
    <div key={activity.time} className={styles.feedsGetStartedActivity}>
      <div className={styles.feedsGetStartedActivityAvatar}>
        <Avatar
          size={40}
          circle
          image={activity.actor?.data?.profileImage || avatar}
        />
      </div>
      <div className={styles.feedsGetStartedActivityContent}>
        <div className={styles.feedsGetStartedActivityHeader}>
          <p className={styles.feedsGetStartedActivityUsername}>
            {actorName}{' '}
            <span className={styles.feedsGetStartedActivityHandle}>
              {activity.actor?.data?.handle || ''}
            </span>
          </p>
          <span className={styles.feedsGetStartedActivityTimestamp}>
            {activityTime || '00:00'}
          </span>
        </div>
        {activity.youtube_id && (
          <div className={styles.feedsGetStartedActivityYoutube}>
            <Video
              og={{
                videos: [
                  {
                    type: 'text/html',
                    secure_url: `https://www.youtube.com/embed/${activity.youtube_id}`,
                    width: activityProps.repost ? 220 : 312,
                  },
                ],
              }}
            />
          </div>
        )}
        {activity.tweet && (
          <p className={styles.feedsGetStartedActivityTweet}>
            {activity.tweet}
          </p>
        )}
        {activity.verb === 'repost' && activity.object instanceof Object && (
          <div className={styles.feedsGetStartedActivityRepost}>
            <Activity repost activity={activity.object} noFooter />
          </div>
        )}
        {!noFooter && (
          <div className={styles.feedsGetStartedActivityFooter}>
            <LikeButton {...activityProps} />
            <RepostButton {...activityProps} />
          </div>
        )}
      </div>
    </div>
  );
};

export const Activity = memo(ActivityComponent);
